function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgSurvey(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M60 24H20a4 4 0 000 8h40a4 4 0 000-8zM64 48a4 4 0 00-4-4H20a4 4 0 000 8h40a4 4 0 004-4zM20 64a4 4 0 000 8h24a4 4 0 000-8H20zM94.915 33.261a4 4 0 00-5.653-.177l-33 31a4 4 0 00-.177 5.653A3.982 3.982 0 0059.001 71a3.98 3.98 0 002.737-1.085l33-31a3.999 3.999 0 00.177-5.654z"
  }), React.createElement("path", {
    d: "M76 64a4 4 0 00-4 4v12.121C72 84.466 68.976 88 65.258 88H14.742C11.024 88 8 84.466 8 80.121V15.878C8 11.534 11.024 8 14.742 8h50.516C68.976 8 72 11.534 72 15.878V36a4 4 0 008 0V15.878C80 7.123 73.387 0 65.258 0H14.742C6.613 0 0 7.123 0 15.878v64.243C0 88.877 6.613 96 14.742 96h50.516C73.387 96 80 88.877 80 80.121V68a4 4 0 00-4-4z"
  }));
}

SvgSurvey.clsName = 'icon-www__survey';
SvgSurvey.remarkName = 'unknown';
export default SvgSurvey;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Survey.js
// module id = 2438
// module chunks = 17 18